<!--返回顶部-->
<template>
  <van-button class="back" size="small" round icon="arrow-up" @click="goTop">顶部</van-button>
</template>

<script>
import { Button } from 'vant';
export default {
  components: {
    [Button.name]: Button,
  },
  name: 'Button',
  data() {
    return {
      gotop: false
    }
  },
  props: {
  },
  mounted() {
    //此处true 需要加上 不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //跳转顶部
    handleScroll() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    goTop() {
      // window.scroll(0,0);
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 10);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
  }
}
</script>

<style lang="less" scoped>
.back {
  position: fixed;
  bottom: 80px;
  margin-left: 80%;
  z-index: 99999999999;
}
</style>
